/**
 * @module NotificationsReactCssCx
 * @package @geenius/notifications-react-css
 * @description Provides the lightweight class name composition helper used by
 * the React CSS notifications components and pages. The helper keeps the CSS
 * variant free of Tailwind-specific utilities and extra runtime dependencies.
 */

/**
 * Merges static and conditional class names for the React CSS variant.
 *
 * @param classes Class name strings where falsy values are ignored.
 * @returns A space-delimited class name string containing only truthy values.
 */
export function cx(...classes: (string | false | null | undefined)[]): string {
  return classes.filter(Boolean).join(' ')
}
